<p [ngClass]="{'color-black': data.type === AlertEnum.warn}">{{ data.message }}</p>

<button mat-icon-button
        [ngClass]="{'color-black': data.type === AlertEnum.warn}"
        [attr.aria-label]="data.action"
        (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
